import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import {
  BuildingDTO,
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import BuildingItem from './BuildingItem/BuildingItem.vue';
import DialogAddEditBuilding from './DialogAddEditBuilding/DialogAddEditBuilding.vue';

@Options({
  name: 'EntrancePlantStructure',
  props: {
    infoPlant: {
      required: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    BuildingItem,
    DialogAddEditBuilding,
  },
  emits: ['update-list'],
})
export default class EntrancePlantStructure extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isVisibleAddEditBuilding = false;

  async mounted() {}

  get buildings() {
    return this.currentEntrancePlant.buildings;
  }
  
  get apartmentsAvailable() {
    return this.currentEntrancePlant.buildings!.reduce(
      (acc, building) => acc + building.apartments!.length,
      0
    ) < 3999;
  }

  goToBuilding(building: BuildingDTO) {
    this.$router.push({
      name: 'page-entranceplant-structure-building',
      params: { buildingId: building.buildingId ?? '' },
    });
  }

  toggleAddEditBuilding() {
    this.isVisibleAddEditBuilding = !this.isVisibleAddEditBuilding;
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
